//import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { BhutilProvider } from '../../providers/bhutil/bhutil';
import { TranslateService } from '@ngx-translate/core';

/*
  Generated class for the RefdataProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/


@Injectable({
    providedIn: 'root'
})
export class RefdataProvider {

  private env = "test";
  private assetBaseUrl = "assets/";
  public svgBaseUrl = this.assetBaseUrl + "svg/";
  public pngBaseUrl = this.assetBaseUrl + "png/";
  public iconBaseUrl = this.assetBaseUrl + "icons/";
  public imageBaseUrl = this.assetBaseUrl + "images/";

  public titleHexagonStyle = 'opacity:0.9;fill:#ffdd58;fill-opacity:1;fill-rule:evenodd;stroke:#ffcc00;stroke-width:2.5;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;';
  public aromaHexagonStyle = 'opacity:0.9;fill:none;fill-opacity:1;fill-rule:evenodd;stroke:#ffcc00;stroke-width:2.5;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;';
  public smallAromaHexagonStyle = 'opacity:0.9;fill-opacity:1;fill-rule:evenodd;stroke:#ffcc00;stroke-width:2.0;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;';
  public aromaHexagonBaseStyle = 'opacity:0.9;fill-opacity:1;fill-rule:evenodd;stroke:#ffcc00;stroke-width:2.5;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;';

  public defaultFontColor = '#544c44';
  constructor(private plt: Platform, private bhutil: BhutilProvider, private translateService: TranslateService) {
    console.log('Hello RefdataProvider Provider');
  }

  public getLegendText(index: number) {
    switch(index) {
      case 0:
        return this.translateService.instant('SWEETVALUE.ABSENT');
      case 1:
        return this.translateService.instant('SWEETVALUE.MILD');
      case 2:
        return this.translateService.instant('SWEETVALUE.MODERATE');
      case 3:
        return this.translateService.instant('SWEETVALUE.HEAVY');
      case 4:
        return this.translateService.instant('SWEETVALUE.DOMINANT');
    }
  }


  public getEnv() {
    return this.env;
  }
  public isProd(): boolean {
    return this.env == "prod";
  }
  public isNonProd(): boolean {
    return !this.isProd();
  }
  public getEnvVar(key: string) {
    let vars = this.envvars[this.env];
    let varKey = vars[key];
    return varKey;
  }
  private envvars = {
    dev: {
      apiBaseUrl: 'https://m0ez73anri.execute-api.eu-west-1.amazonaws.com/test/api/app',
      xapikey: 'Key1SV0ce45i4Dhrob6VP74IWR45IqRb2wVur7rx',
      loginBaseUrl: 'http://192.168.1.10:9000/login',
      loginApiBaseUrl: 'http://192.168.1.10:9000',
      clientId: '504j2cqts5btjjuhro1h1lpbcv',
      awsUserPoolId: 'eu-west-1_Q9Kd3gUOG',
      awsRegion: 'eu-west-1',
      beerLogoBaseUrl: 'http://beerhive-test.s3-website-eu-west-1.amazonaws.com/beerhiveapp/beer/final-logos/160x120/',
      breweryLogoBaseUrl: 'http://beerhive-test.s3-website-eu-west-1.amazonaws.com/beerhiveapp/brewery/final-logos/160x120/'
    },
    test: {
      apiBaseUrl: 'https://m0ez73anri.execute-api.eu-west-1.amazonaws.com/test/api/app',
      xapikey: 'Key1SV0ce45i4Dhrob6VP74IWR45IqRb2wVur7rx',
      loginBaseUrl: 'https://test-secure.beerhive.com/login',
      loginApiBaseUrl: 'https://test-secure.beerhive.com',
      clientId: '27lpqv2d15r80om2a48u4hev9g',
      awsRegion: 'eu-west-1',
      awsUserPoolId: 'eu-west-1_9fExuH8dA',
      beerLogoBaseUrl: 'http://beerhive-test.s3-website-eu-west-1.amazonaws.com/beerhiveapp/beer/final-logos/160x120/',
      breweryLogoBaseUrl: 'http://beerhive-test.s3-website-eu-west-1.amazonaws.com/beerhiveapp/brewery/final-logos/160x120/'
//      beerLogoBaseUrl: 'https://beerhive-test.s3.amazonaws.com/beer/final-logos/160x120/',
//      breweryLogoBaseUrl: 'https://beerhive-test.s3.amazonaws.com/brewery/final-logos/160x120/'
    },
    prod: {
      apiBaseUrl: 'https://acsy4iz7ob.execute-api.eu-west-1.amazonaws.com/prod/api/app',
      xapikey: 'Key1SV0ce45i4Dhrob6VP74IWR45IqRb2wVur7rx',
      loginBaseUrl: 'https://secure.beerhive.com/login',
      loginApiBaseUrl: 'https://secure.beerhive.com',
      clientId: '3n5tipsbtgbf86gluhjn017osn',
      awsRegion: 'eu-west-1',
      awsUserPoolId: 'eu-west-1_1EEH04AdT',
      beerLogoBaseUrl: 'http://beerhive-prod.s3-website-eu-west-1.amazonaws.com/beerhiveapp/beer/final-logos/160x120/',
      breweryLogoBaseUrl: 'http://beerhive-prod.s3-website-eu-west-1.amazonaws.com/beerhiveapp/brewery/final-logos/160x120/'
    }
  };

  public isInApp(): boolean {
    return this.plt.is('cordova');
  }

  public isAndroid(): boolean {
    return this.plt.is('android');
  }

  public getApplicationWidth() {
    return Math.min(window.innerWidth, 768);
  }
}
